import React from 'react'
import * as bs4 from 'reactstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import Select from 'react-select';
import Navbar from '../Navbar'
import { ScaleLoader } from 'react-spinners';
const { proxy } = require('../../ip_api.config')

class Flim_EditItem extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            id: '',
            isLoading: false,
            arr_item: [],
            arr_check: [],
            arr_show: [],
            arr_save: [],
        }
    }

    componentDidMount() {
        if (localStorage.getItem("ID_User") !== null) {
            // console.log('id', this.props.location.state.id_edit)
            this.setState({
                id: this.props.location.state.id_edit
            }, () => {
                this.push_arrItemSave()
            })
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    push_arrItemSave = () => {
        this.setState({ isLoading: true })
        let arr = []
        let temp
        let url = proxy.server + '/flim/get_Viewitem'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: this.state.id
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    let data = {
                        product_type: val.product_type,
                        dbname: val.db_name,
                        name: val.ItemId,
                        description: val.SearchName,
                        gross_width: val.grossWidth,
                        gross_height: val.grossHeight,
                        line_discount_group: val.InventTableModuleSales_LineDisc,
                        itemG4: val.ECL_ItemCategoryIdG4,
                        ibrand3: val.ECL_ItemCategoryIdBrand3,
                        ibrand3_des: val.ECL_ItemCategoryIdBrand3,
                        ibrand4_code: val.ECL_ItemCategoryIdBrand4,
                        buyer_group: val.ItemBuyerGroupId,
                        itemG1: val.ECL_ItemCategoryIdG1,
                        itemG2: val.ECL_ItemCategoryIdG2,
                        itemG3: val.ECL_ItemCategoryIdG3,
                        ibrand1: val.ECL_ItemCategoryIdBrand1,
                        ibrand2: val.ECL_ItemCategoryIdBrand2,
                        status_item: val.DPL_StatusItem,
                        unit_Collect: val.InventTableModuleInvent_UnitId,
                        unit_Buy: val.InventTableModulePurch_UnitId,
                        unit_Sale: val.InventTableModuleSales_UnitId,
                        DefaultOrderType: val.DefaultOrderType,
                        EcoResTrackingDimensionGroup_Name: val.EcoResTrackingDimensionGroup_Name,
                        ItemGroupId: val.ItemGroupId,
                        CostGroupId: val.CostGroupId,
                        BatchNumGroupId: val.BatchNumGroupId,
                        SerialNumGroupId: val.SerialNumGroupId,
                        InventTableModuleInvent_UnitId: val.InventTableModuleInvent_UnitId,
                        InventTableModulePurch_UnitId: val.InventTableModulePurch_UnitId,
                        InventTableModulePurch_OverDeliveryPct: val.InventTableModulePurch_OverDeliveryPct,
                        InventTableModulePurch_UnderDeliveryPct: val.InventTableModulePurch_UnderDeliveryPct,
                        InventTableModuleSales_UnitId: val.InventTableModuleSales_UnitId,
                        ECL_NumberSequenceGroupProd: val.ECL_NumberSequenceGroupProd,
                        BOMUnitId: val.BOMUnitId,
                        DefaultDimension: val.DefaultDimension,
                        PurchInventLocationId: val.PurchInventLocationId,
                        ItemInventLocationId: val.ItemInventLocationId,
                        SalesInventLocationId: val.SalesInventLocationId,
                        image: val.image
                    }

                    arr.push(data)
                })
                temp = this.state.arr_save.concat(arr)
                this.setState({ arr_save: temp }, () => { this.set_arrItemSave() })
            })
    }

    get_dataStandrad = async (itemG1) => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/get_dataStandrad'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                itemG1: itemG1,
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                // console.log("get_dataStandrad", responseJson.result[0])
                if (responseJson.result.lenght !== []) {
                    resolve(responseJson.result[0])
                } else {
                    resolve(0)
                }
            })
    })

    get_dataWarehourse = async (itemG1, dbname) => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/get_dataWarehourse'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                itemG1: itemG1,
                dbname: dbname
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                // console.log("get_dataWarehourse", responseJson.result)
                if (responseJson.result.lenght !== []) {
                    resolve(responseJson.result[0])
                } else {
                    resolve(0)
                }
            })
    })

    set_arrItemSave = async () => {
        this.setState({ isLoading: true })

        const { arr_save } = this.state
        let arr = []

        arr = await Promise.all(arr_save.map(async function (val, i) {
            let dataStandrad = await this.get_dataStandrad(val.name.substr(0, 3))
            let dataWearhouse = await this.get_dataWarehourse(val.name.substr(0, 3), val.dbname)
            console.log('dataWearhouse', dataWearhouse)

            let itemG1 = val.product_type === 'Focus' || val.product_type === 'Ablemen' ? val.name.substr(0, 3)
                : val.product_type === 'Other' ? val.name.charAt(0) === 'R' ? 'RM' : val.name.substr(0, 3) : ''

            let itemG3 = val.product_type === 'Focus' || val.product_type === 'Ablemen' ? val.itemG3
                : val.product_type === 'Other' ? itemG1 === 'RM' ? val.name.substr(0, 3) : '' : ''

            let buyerGoup = itemG1 === 'G08' || itemG1 === 'G05'
                || itemG1 === 'G0A' || itemG1 === 'S05' || itemG1 === 'TAB' ? ''
                : itemG1 === 'S08' ? 'CN' : itemG1 === 'T0A' ? 'CN-FAC'
                    : itemG1 === 'S0A' && itemG3 === 'TG-UC' ? 'CN-FAC'
                        : itemG1 === 'S0A' && itemG3 === 'HR-CL' ? 'CN-FAC'
                            : itemG1 === 'S0A' && itemG3 === 'TG-FF HD' ? 'CN-FAC'
                                : itemG1 === 'S0A' && itemG3 === 'HR-FF' ? 'CN-FAC'
                                    : itemG1 === 'S0A' ? 'CN' : ''

            let itemG2 = val.product_type === 'Focus' || val.product_type === 'Ablemen' ? val.ibrand1
                : val.name.substr(0, 2) === 'RF' ? 'RM-FILM'
                    : val.name.substr(0, 2) === 'RA' ? 'RM-AB'
                        : val.name.substr(0, 2) === 'RT' ? 'RM-TG'
                            : val.name.substr(0, 5)

            let status_item = val.product_type === 'Other' ? 1
                : itemG1 === 'G08' || itemG1 === 'G0A' ? 0
                    : itemG1 === 'G05' ? 1
                        : ''

            this.state.arr_save[i].buyerGoup = buyerGoup
            this.state.arr_save[i].itemG1 = itemG1
            this.state.arr_save[i].itemG2 = itemG2
            this.state.arr_save[i].itemG3 = itemG3
            this.state.arr_save[i].status_item = status_item

            this.state.arr_save[i].unit_Collect = dataStandrad === undefined || dataStandrad.InventTableModuleInvent_UnitId === null ? '' : dataStandrad.InventTableModuleInvent_UnitId
            this.state.arr_save[i].unit_Buy = dataStandrad === undefined || dataStandrad.InventTableModulePurch_UnitId === null ? '' : dataStandrad.InventTableModulePurch_UnitId
            this.state.arr_save[i].unit_Sale = dataStandrad === undefined || dataStandrad.InventTableModuleSales_UnitId === null ? '' : dataStandrad.InventTableModuleSales_UnitId
            this.state.arr_save[i].DefaultOrderType = dataStandrad === undefined || dataStandrad.DefaultOrderType === null ? '' : dataStandrad.DefaultOrderType
            this.state.arr_save[i].EcoResTrackingDimensionGroup_Name = dataStandrad === undefined || dataStandrad.EcoResTrackingDimensionGroup_Name === null ? '' : dataStandrad.EcoResTrackingDimensionGroup_Name
            this.state.arr_save[i].ItemGroupId = dataStandrad === undefined || dataStandrad.ItemGroupId === null ? '' : dataStandrad.ItemGroupId
            this.state.arr_save[i].CostGroupId = dataStandrad === undefined || dataStandrad.CostGroupId === null ? '' : dataStandrad.CostGroupId
            this.state.arr_save[i].BatchNumGroupId = dataStandrad === undefined || dataStandrad.BatchNumGroupId === null ? '' : dataStandrad.BatchNumGroupId
            this.state.arr_save[i].SerialNumGroupId = dataStandrad === undefined || dataStandrad.SerialNumGroupId === null ? '' : dataStandrad.SerialNumGroupId
            this.state.arr_save[i].InventTableModuleInvent_UnitId = dataStandrad === undefined || dataStandrad.InventTableModuleInvent_UnitId === null ? '' : dataStandrad.InventTableModuleInvent_UnitId
            this.state.arr_save[i].InventTableModulePurch_UnitId = dataStandrad === undefined || dataStandrad.InventTableModulePurch_UnitId === null ? '' : dataStandrad.InventTableModulePurch_UnitId
            this.state.arr_save[i].InventTableModulePurch_OverDeliveryPct = dataStandrad === undefined || dataStandrad.InventTableModulePurch_OverDeliveryPct === null ? '' : dataStandrad.InventTableModulePurch_OverDeliveryPct
            this.state.arr_save[i].InventTableModulePurch_UnderDeliveryPct = dataStandrad === undefined || dataStandrad.InventTableModulePurch_UnderDeliveryPct === null ? '' : dataStandrad.InventTableModulePurch_UnderDeliveryPct
            this.state.arr_save[i].InventTableModuleSales_UnitId = dataStandrad === undefined || dataStandrad.InventTableModuleSales_UnitId === null ? '' : dataStandrad.InventTableModuleSales_UnitId
            this.state.arr_save[i].ECL_NumberSequenceGroupProd = dataStandrad === undefined || dataStandrad.ECL_NumberSequenceGroupProd === null ? '' : dataStandrad.ECL_NumberSequenceGroupProd
            this.state.arr_save[i].BOMUnitId = dataStandrad === undefined || dataStandrad.BOMUnitId === null ? '' : dataStandrad.BOMUnitId
            this.state.arr_save[i].DefaultDimension = dataStandrad === undefined || dataStandrad.DefaultDimension === null ? '' : dataStandrad.DefaultDimension

            this.state.arr_save[i].PurchInventLocationId = dataWearhouse === undefined || dataWearhouse.PurchInventLocationId === null ? '' : dataWearhouse.PurchInventLocationId
            this.state.arr_save[i].ItemInventLocationId = dataWearhouse === undefined || dataWearhouse.ItemInventLocationId === null ? '' : dataWearhouse.ItemInventLocationId
            this.state.arr_save[i].SalesInventLocationId = dataWearhouse === undefined || dataWearhouse.SalesInventLocationId === null ? '' : dataWearhouse.SalesInventLocationId

            // return true
        }, this))

        this.setState({ arr_save: this.state.arr_save }, () => this.getItem_Preview())
    }

    getItem_Preview = async () => {
        let arr = []

        arr = await Promise.all(this.state.arr_save.map(async function (val, i) {
            console.log("val", val)
            return <tr>
                {
                    val.dbname === 'DPL' ?
                        <td style={{ backgroundColor: '#00BFFF', color: '#000' }}>{val.dbname}</td>
                        : val.dbname === 'DFIX' ?
                            <td style={{ backgroundColor: '#00FA9A', color: '#000' }}>{val.dbname}</td>
                            : val.dbname === 'DPT' ?
                                <td style={{ backgroundColor: '#fec23e', color: '#000' }}>{val.dbname}</td>
                                : < td>{val.dbname}</td>
                }
                {val.name.length > 20
                    ? <td style={{ color: 'red' }}>
                        ***ขนาดเกิน 20 ตัวอักษร
                        <bs4.Col sm='12' style={{ width: 250 }}>
                            <bs4.Input type="textarea" name="name" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.name} />
                        </bs4.Col>
                    </td>
                    : <td>
                        <bs4.Col sm='12' style={{ width: 250 }}>
                            <bs4.Input type="text" name="name" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.name} />
                        </bs4.Col>
                    </td>
                }
                {val.description.length > 60
                    ? <td style={{ color: 'red' }}>
                        ***ขนาดเกิน 60 ตัวอักษร
                        <bs4.Col sm='12' style={{ width: 250 }}>
                            <bs4.Input type="textarea" name="description" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.description} />
                        </bs4.Col>
                    </td>
                    :
                    <td>
                        <bs4.Col sm='12' style={{ width: 250 }}>
                            <bs4.Input type="textarea" name="description" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.description} />
                        </bs4.Col>
                    </td>
                }
                <td>
                    <bs4.Col sm='12' style={{ width: 100 }}>
                        <bs4.Input type="text" name="gross_width" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.gross_width} />
                    </bs4.Col>
                </td>
                <td>
                    <bs4.Col sm='12' style={{ width: 100 }}>
                        <bs4.Input type="text" name="gross_height" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.gross_height} />
                    </bs4.Col>
                </td>
                <td>
                    <bs4.Col sm='12' style={{ width: 200 }}>
                        <bs4.Input type="text" name="line_discount_group" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.line_discount_group} />
                    </bs4.Col>
                </td>
                <td>
                    <bs4.Col sm='12' style={{ width: 200 }}>
                        <bs4.Input type="text" name="itemG4" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.itemG4} />
                    </bs4.Col>
                </td>
                <td>
                    <bs4.Col sm='12' style={{ width: 200 }}>
                        <bs4.Input type="text" name="ibrand3" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.ibrand3} />
                    </bs4.Col>
                </td>
                <td>
                    <bs4.Col sm='12' style={{ width: 200 }}>
                        <bs4.Input type="text" name="ibrand4_code" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.ibrand4_code} />
                    </bs4.Col>
                </td>
                <td>{val.buyerGoup}</td>
                <td>{val.itemG1}</td>
                <td>{val.itemG2}</td>
                <td>{val.itemG3}</td>
                <td>{val.ibrand1}</td>
                <td>{val.ibrand2}</td>
                <td>{val.status_item}</td>
                <td>{val.InventTableModuleInvent_UnitId}</td>
                <td>{val.InventTableModulePurch_UnitId}</td>
                <td>{val.InventTableModuleSales_UnitId}</td>
            </tr >
        }, this))
        this.setState({ previewItem: arr, isLoading: false })
    }

    handleChangeItem = (index, name, value) => {
        if (name === 'name') {
            this.state.arr_save[index].name = value
        } else if (name === 'description') {
            this.state.arr_save[index].description = value
        } else if (name === 'gross_width') {
            this.state.arr_save[index].gross_width = value
        } else if (name === 'gross_height') {
            this.state.arr_save[index].gross_height = value
        } else if (name === 'line_discount_group') {
            this.state.arr_save[index].line_discount_group = value
        } else if (name === 'itemG4') {
            this.state.arr_save[index].itemG4 = value
        } else if (name === 'ibrand3') {
            this.state.arr_save[index].ibrand3 = value
        } else if (name === 'ibrand4_code') {
            this.state.arr_save[index].ibrand4_code = value
        }

        this.setState({
            arr_save: this.state.arr_save
        }, () => {
            console.log('arr_save', this.state.arr_save)
            this.set_arrItemSave()

        })
    }

    update_item = () => {
        if (window.confirm("กรุณายืนยันการบันทึก")) {
            this.setState({ isLoading: true })
            let url = proxy.server + '/flim/update_item'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify({
                    id: this.state.id,
                    arr: this.state.arr_save
                })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.setState({ isLoading: false })
                        this.props.history.push({
                            pathname: '/Flim/PreviewItem'
                        })
                    } else {
                        this.setState({ isLoading: false })
                        alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                    }
                })
        }
    }

    render() {
        return <div>
            <Navbar nav={'Flim'} menu={'Flim_EditItem'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row style={{ marginLeft: 10, marginBottom: 20 }}>
                    <bs4.Label style={{ fontSize: 20, fontWeight: 500, marginRight: 20 }} >EDIT ITEM</bs4.Label>
                    <bs4.Button color="warning" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.update_item()}>SAVE</bs4.Button>
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>
                <bs4.Table bordered hover style={{ fontSize: 15 }}>
                    <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            <th>ฐานข้อมูล</th>
                            <th style={{ backgroundColor: '#61ba52' }}>Code</th>
                            <th style={{ backgroundColor: '#61ba52' }}>Name</th>
                            <th>Gross Width</th>
                            <th>Gross Height</th>
                            <th>Line Discount Group</th>
                            <th>Item G4</th>
                            <th>Ibrand3</th>
                            <th>Ibrand4</th>
                            <th style={{ backgroundColor: '#61ba52' }}>กลุ่ม<br />ในการ<br />สั่งซือ</th>
                            <th style={{ backgroundColor: '#61ba52' }}>Item G1</th>
                            <th style={{ backgroundColor: '#61ba52' }}>Item G2</th>
                            <th style={{ backgroundColor: '#61ba52' }}>Item G3</th>
                            <th style={{ backgroundColor: '#61ba52' }}>Ibrand1</th>
                            <th style={{ backgroundColor: '#61ba52' }}>Ibrand2</th>
                            <th style={{ backgroundColor: '#61ba52' }}>Status Item</th>
                            <th>ระบุหน่วยจัดเก็บ</th>
                            <th>ระบุหน่วยซื้อ</th>
                            <th>ระบุหน่วยขาย</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.previewItem}
                    </tbody>
                </bs4.Table>
            </div>
        </div>
    }
}

export default Flim_EditItem